// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"b96ee823","36":"31d6cfe0","219":"f1b0a98f","492":"f4215eb4","586":"f54d1516","621":"a257a8b8","634":"f4d0165e","726":"b96ee823"}[chunkId] + ".chunk.css";
};